import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

// pages
import DashboardLayout from "../components/layout/DashboardLayout";
import LeadManagementPage from "../pages/LeadManagement/leadManagement";
import Login from "../pages/auth/Login";
import Voicebot from "../pages/voicebot/voicebot";
import Reports from "../pages/Reports/reports";
import AgentDashboard from "../pages/agent/AgentDashboard";
import AgentCampaigns from "../pages/agent/AgentCampaigns";
import CampaignLeadList from "../pages/agent/CampaignLeadList";
import CampaignLeadById from "../pages/agent/CampaignLeadById";
import CampaignList from "../pages/CampaignList";
import VoiceBotPipe from "../pages/voicebot/VoiceBotPipe";

export default function AppRoutes() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<Login />} />
        <Route path="/agent" element={<DashboardLayout />}>
          <Route path="dashboard" element={<AgentDashboard />} />
          <Route path="campaigns">
            <Route index element={<AgentCampaigns />} />
            <Route path="lead/:id" element={<CampaignLeadById />} />
            <Route path=":id" element={<CampaignLeadList />} />
          </Route>
        </Route>

        <Route element={<DashboardLayout />}>
          <Route path="dashboard" element={<>Dashboard</>} />
          <Route path="lead-management" element={<LeadManagementPage />} />
          <Route path="voicebot" element={<VoiceBotPipe />} />
          <Route path="reports" element={<Reports />} />
          <Route path="campaigns" element={<CampaignList />} />
        </Route>
        <Route path="*" element={<p>Page not found</p>} />
      </>
    )
  );

  return <RouterProvider router={router} />;
}
